import React from "react";
import * as styles from "./parts.module.scss";

export const Logo = () => (
  <img src="/logoFr.png" alt="tours ecard logo" className={styles.logo} />
);
